import { Component, OnInit, Input } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductService } from '../../shared/services/product.service';

@Component({
  selector: 'app-quick-look',
  templateUrl: './quick-look.component.html',
  styleUrls: ['./quick-look.component.scss']
})
export class QuickLookComponent implements OnInit {

  @Input() public activeProductId;

  product;
  
  constructor(private modalService: NgbModal,public activeModal: NgbActiveModal, private productService:ProductService) { }
  
  getProduct(productId){
    this.productService
    .getProduct(productId)
    .subscribe( res => this.product = res);
  }

  ngOnInit() {
    this.getProduct(this.activeProductId);
  }

  close() {
    this.activeModal.close();
  }
}
